import React from 'react';
import { CaptionText, Col, grey600, Row } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';

function ConfirmationTransactionId(props) {
  return (
    <Row>
      <Col id="transactionId" xs={12} className="text-center">
        <CaptionText
          style={{
            color: grey600,
          }}
        >
          {props.transactionId}
        </CaptionText>
      </Col>
    </Row>
  );
}

ConfirmationTransactionId.propTypes = {
  transactionId: PropTypes.string,
};

export default ConfirmationTransactionId;
